<template>
    <tr @click="$emit('rowClick', row)" :class="backgroundClass">
        <table-cell
            v-for="column in visibleColumns"
            :row="row"
            :column="column"
            :key="column.id"
        ></table-cell>
    </tr>
</template>

<script>
    import TableCell from './TableCell';

    export default {
        props: ['columns', 'row'],

        components: {
            TableCell,
        },

        computed: {
            visibleColumns() {
                return this.columns.filter(column => ! column.hidden);
            },
            backgroundClass(){
                return 'table-' + this.status.color(this.row.data.status);
            }
        },
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table/TableRow.vue